import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Chart from "react-apexcharts";
import { Doughnut } from "react-chartjs-2";
import { Payroll_API_BASE_URL } from "../PConfig/PConfig";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import "antd/dist/reset.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const PayrollDashboard = () => {
  // const [selectedMonth, setSelectedMonth] = useState(dayjs());
  const [selectedMonth, setSelectedMonth] = useState(dayjs("2022-03"));
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [CardsCounts, setCardsCounts] = useState([]);
  const [DeptwiseCounts, setDeptwiseCounts] = useState([]);
  const [PayrollCounts, setPayrollCounts] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    // const superId = sessionStorage.getItem("superId");
    const superId = sessionStorage.getItem("PayrollSuperId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchCardsCounts = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}payroll/DashBoard/getpayrollcounts?SuperId=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${tokenData}`,
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,

              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Employees");
          }

          const data = await response.json();

          if (data.status) {
            setCardsCounts(data.ResultData);
          } else {
            console.error("Invalid Employees response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching EmployeesList:", error.message);
        }
      };
      fetchCardsCounts();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData && selectedMonth) {
      const fetchDeptCounts = async () => {
        try {
          const month = selectedMonth.month() + 1;
          const year = selectedMonth.year();

          const response = await fetch(
            `${Payroll_API_BASE_URL}payroll/DashBoard/getDepartmentWiseSalaries?SuperId=${superIdData}&Month=${month}&Year=${year}`,
            {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${tokenData}`,
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch department salaries");
          }

          const data = await response.json();

          if (data.status) {
            setDeptwiseCounts(data.ResultData);
          }
        } catch (error) {
          console.error("Error fetchDeptCounts:", error.message);
        }
      };

      fetchDeptCounts();
    }
  }, [tokenData, superIdData, selectedMonth]);
  
  useEffect(() => {
    if (tokenData && superIdData && selectedMonth) {
      const fetchPayrollCounts = async () => {
        try {
          const month = selectedMonth.month() + 1;
          const year = selectedMonth.year();

          const response = await fetch(
            `${Payroll_API_BASE_URL}payroll/DashBoard/getPayrollOverviewCount?SuperId=${superIdData}&Month=${month}&Year=${year}`,
            {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${tokenData}`,
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch payroll counts");
          }

          const data = await response.json();

          if (data.status) {
            setPayrollCounts(data.ResultData[0]);
          }
        } catch (error) {
          console.error("Error fetchPayrollCounts:", error.message);
        }
      };

      fetchPayrollCounts();
    }
  }, [tokenData, superIdData, selectedMonth]);

  const departmentNames = DeptwiseCounts.map(
    (item) => item.DepartmentName
  );

  const departmentSalaryValues = DeptwiseCounts.map(
    (item) => Number(item.DeptMonthlySalary.toFixed(2))
  );

  // Static month-wise salary data (last 12 months)
  // const monthlySalaries = [
  //   { month: "Jan 2025", salary: 1450000 },
  //   { month: "Feb 2025", salary: 1520000 },
  //   { month: "Mar 2025", salary: 1480000 },
  //   { month: "Apr 2025", salary: 1590000 },
  //   { month: "May 2025", salary: 1620000 },
  //   { month: "Jun 2025", salary: 1550000 },
  //   { month: "Jul 2025", salary: 1680000 },
  //   { month: "Aug 2025", salary: 1700000 },
  //   { month: "Sep 2025", salary: 1650000 },
  //   { month: "Oct 2025", salary: 1720000 },
  //   { month: "Nov 2025", salary: 1780000 },
  //   { month: "Dec 2025", salary: 1890000 },
  // ];

  const departmentChartOptions = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        columnWidth: "55%",
      },
    },
    dataLabels: { enabled: false },
    colors: ["#4F46E5"],
    xaxis: {
      categories: departmentNames,
      labels: {
        rotate: -45,
        style: { fontSize: "11px" },
      },
    },
    yaxis: {
      title: { text: "Salary (₹)" },
      labels: {
        formatter: (val) => `₹${(val / 1000).toFixed(0)}K`,
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `₹${val.toLocaleString("en-IN")}`,
      },
    },
  };

  const departmentChartSeries = [
    {
      name: "Monthly Salary",
      data: departmentSalaryValues,
    },
  ];


  // Line Chart: Month Wise Salaries
  // const monthlyChartOptions = {
  //   chart: {
  //     type: "line",
  //     height: 350,
  //     toolbar: { show: false },
  //   },
  //   stroke: {
  //     curve: "smooth",
  //     width: 3,
  //   },
  //   colors: ["#10B981"],
  //   xaxis: {
  //     categories: monthlySalaries.map((m) => m.month),
  //   },
  //   yaxis: {
  //     title: { text: "Total Salary (₹)" },
  //     labels: {
  //       formatter: (val) => `₹${(val / 100000).toFixed(1)}L`,
  //     },
  //   },
  //   grid: { borderColor: "#E5E7EB" },
  //   tooltip: {
  //     y: {
  //       formatter: (val) => `₹${val.toLocaleString()}`,
  //     },
  //   },
  //   markers: {
  //     size: 5,
  //   },
  // };

  // const monthlyChartSeries = [
  //   {
  //     name: "Total Payroll",
  //     data: monthlySalaries.map((m) => m.salary),
  //   },
  // ];

  const doughnutData = PayrollCounts && {
    labels: [
      "Basic",
      "HRA",
      "Special Allowance",
      "Conveyance",
      "Medical Allowance",
    ],
    datasets: [
      {
        data: [
          PayrollCounts.Basic,
          PayrollCounts.Hra,
          PayrollCounts.SpecialAllowance,
          PayrollCounts.ConveyanceAllowance,
          PayrollCounts.MedicalAllowance,
        ],
        backgroundColor: [
          "#4F46E5", // Basic
          "#10B981", // HRA
          "#F59E0B", // Special Allowance
          "#3B82F6", // Conveyance
          "#EF4444", // Medical
        ],
        borderWidth: 3,
        cutout: "70%",
      },
    ],
  };
  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "right" },
      tooltip: {
        callbacks: {
          label: (ctx) =>
            `₹${ctx.raw.toLocaleString("en-IN")}`,
        },
      },
    },
  };

  const getCurrentMonthYear = () => {
    return selectedMonth.format("MMMM YYYY");
  };

  return (
    <>
      <style>
        {`.month-picker-compact.ant-picker {
  width: 170px !important;
  min-width: 170px !important;
}
      `}
      </style>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
            <div>
              <h1 className="mb-1">Payroll</h1>
              <p className="fw-medium text-muted">
                Overview of payroll statistics and salary distribution
              </p>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="row mb-4">
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="card bg-secondary sale-widget flex-fill">
                <div className="card-body d-flex align-items-center">
                  <span className="sale-icon bg-white text-secondary">
                    <i className="ti ti-users fs-24" />
                  </span>
                  <div className="ms-3">
                    <p className="text-white mb-1">YTD Salarys</p>
                    <h4 className="text-white">₹{CardsCounts[0]?.YTDSalarys}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="card bg-primary sale-widget flex-fill">
                <div className="card-body d-flex align-items-center">
                  <span className="sale-icon bg-white text-primary">
                    <i className="ti ti-building fs-24" />
                  </span>
                  <div className="ms-3">
                    <p className="text-white mb-1">Last Month Salarys</p>
                    <h4 className="text-white">₹{CardsCounts[0]?.LastMonthSalarys}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="card bg-success sale-widget flex-fill">
                <div className="card-body d-flex align-items-center">
                  <span className="sale-icon bg-white text-success">
                    <i className="ti ti-calendar-event fs-24" />
                  </span>
                  <div className="ms-3">
                    <p className="text-white mb-1">Total OTs Paid</p>
                    <h4 className="text-white">₹{CardsCounts[0]?.TotalOTsPaid} </h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="card bg-info sale-widget flex-fill">
                <div className="card-body d-flex align-items-center">
                  <span className="sale-icon bg-white text-info">
                    <i className="ti ti-calendar-month fs-24" />
                  </span>
                  <div className="ms-3">
                    <p className="text-white mb-1">Forecast</p>
                    <h4 className="text-white">₹{CardsCounts[0]?.Forecast} </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Charts Row */}
          <div className="row">
            {/* Department Wise Salaries - Bar Chart */}
            <div className="col-12 col-lg-8 d-flex">
              <div className="card flex-fill">
                <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                  <h5 className="card-title mb-0">
                    <i className="fa-solid fa-chart-bar me-2"></i>
                    Department Wise Salaries
                  </h5>

                  {/* Month Filter - Only for this chart */}
                  <div className="d-flex align-items-center gap-2">
                    <DatePicker
                      picker="month"
                      format="MMMM YYYY"
                      className="month-picker-compact"
                      value={selectedMonth}
                      onChange={(date) => setSelectedMonth(date || dayjs())}
                      suffixIcon={<i className="ti ti-calendar fs-20" />}
                      allowClear={false}
                      size="middle"
                    />
                  </div>
                </div>

                <div className="card-body">
                  <div className="text-center text-muted mb-3">
                    <small>Showing salary distribution for <strong>{getCurrentMonthYear()}</strong></small>
                  </div>

                  {DeptwiseCounts.length > 0 ? (
                    <Chart
                      options={departmentChartOptions}
                      series={departmentChartSeries}
                      type="bar"
                      height={350}
                    />
                  ) : (
                    <div className="d-flex align-items-center justify-content-center" style={{ height: '350px' }}>
                      <p className="text-muted">
                        No salary data available for {getCurrentMonthYear()}
                      </p>
                    </div>
                  )}

                </div>
              </div>
            </div>

            {/* Payroll Distribution & Stats */}
            <div className="col-12 col-lg-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <h5 className="card-title mb-0">
                    <i className="fa-solid fa-chart-pie me-2"></i>
                    Payroll Overview
                  </h5>
                </div>
                <div className="card-body">
                  <div className="text-center mb-4">
                    <div className="text-center mb-4">
                      {doughnutData ? (
                        <Doughnut
                          data={doughnutData}
                          options={doughnutOptions}
                          height={200}
                        />
                      ) : (
                        <p className="text-muted">Loading payroll breakup...</p>
                      )}
                    </div>

                  </div>
                  <div className="mt-3">
                    {PayrollCounts && (
                      <>
                        <div className="d-flex justify-content-between border-bottom pb-2 mb-2">
                          <span>Total Earnings</span>
                          <strong>₹{PayrollCounts?.Earnings?.toLocaleString("en-IN")}</strong>
                        </div>

                        <div className="d-flex justify-content-between border-bottom pb-2 mb-2">
                          <span>Total Deductions</span>
                          <strong>₹{PayrollCounts?.Deductions?.toLocaleString("en-IN")}</strong>
                        </div>

                        <div className="d-flex justify-content-between">
                          <span>Net Payable</span>
                          <strong className="text-success">
                            ₹{PayrollCounts?.NetPayble?.toLocaleString("en-IN")}
                          </strong>
                        </div>
                      </>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Month Wise Salaries - Line Chart */}
          {/* <div className="row mt-4">
            <div className="col-12 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <h5 className="card-title mb-0">
                    <i className="fa-solid fa-chart-line me-2"></i>
                    Month Wise Salaries (2025)
                  </h5>
                </div>
                <div className="card-body">
                  <Chart
                    options={monthlyChartOptions}
                    series={monthlyChartSeries}
                    type="line"
                    height={350}
                  />
                </div>
              </div>
            </div>
          </div> */}
        </div>

        {/* Footer */}
        <div className="copyright-footer d-flex align-items-center justify-content-between border-top bg-white gap-3 flex-wrap py-3 px-4">
          <p className="fs-13 text-gray-9 mb-0">
            2014-2025 © Pereco. All Rights Reserved
          </p>
          <p className="mb-0">
            Designed & Developed By{" "}
            <Link to="#" className="link-primary">
              Pereco
            </Link>
          </p>
        </div>
      </div>
    </>

  );
};

export default PayrollDashboard;